/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { formatCurrency } from 'utils/user'

import { useTheme, styled } from '@mui/material/styles'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ImageList from '@mui/material/ImageList'
import ImageListItem from '@mui/material/ImageListItem'

import 'hammerjs'

// TODO: Don't use kendo, we will use Apexcharts
import {
  Chart,
  ChartArea,
  ChartAxisDefaults,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesItemTooltip,
  ChartTooltip,
  ChartValueAxis,
  ChartValueAxisItem,
} from '@progress/kendo-react-charts'

import actionTypes from 'store/actions'
import ConnectButton from 'components/Common/Button/ConnectButton'
import DaySpan from 'components/Common/DaySpan'
import SectionTitle from 'components/Common/SectionTitle'
import ToolTip from 'components/Common/ToolTip'
import Overlay from 'components/Common/Overlay'
import ConfirmDialog from 'components/Common/Dialog/ConfirmDialog'
import ButtonTooltip from 'components/Common/ToolTip/ButtonTooltip'

import linkOffSvg from 'assets/link-off.svg'
import cashflowPlaceholderSvg from 'assets/cashflow-img.svg'
import api from 'api'

const items = [
  {
    title: 'quickbooks',
    logoUrl: process.env['REACT_APP_BRC_IMAGE_URL'] + '/06302022/Quickbooks_Logo.svg',
  },
  {
    title: 'intuit',
    logoUrl: process.env['REACT_APP_BRC_IMAGE_URL'] + '/06302022/Intuit_Logo.svg',
  },
  {
    title: 'xero',
    logoUrl: process.env['REACT_APP_BRC_IMAGE_URL'] + '/06302022/Xero_Logo.svg',
  },
]

const CardHeader = styled(Box)(() => ({
  width: '100%',
  height: '30px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
}))

const CardBody = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
}))

const ChartPlaceholder = styled(Box)({
  position: 'relative',
  height: 'calc(100% - 50px)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
})

const CashFlowCard = () => {
  const theme = useTheme()
  const dispatch = useDispatch()

  const userInfo = useSelector(state => state.userReducer)
  const accountCodatConnected = useSelector(state => state.appReducer.accountCodatConnected)
  const commerceCodatConnected = useSelector(state => state.appReducer.commerceCodatConnected)
  const isFreeAccount = userInfo?.user?.accountType !== 'premium'

  const daySpanSelected = useSelector(state => state.appReducer.financialOverviewDaySpan)
  //NOTE: Just for demo
  // const companyId = 'ffc4ec47-8d5a-4704-ac1a-b5f1f1b82f64'
  const companyId = useSelector(state => state.apiResponseReducers.companyId)

  const seriesStyle = `smooth`
  const connectionId = useSelector(state => state.appReducer.accountConnectionId)
  const codatIntegrated = useSelector(state => state.apiResponseReducers.codatIntegrated)

  const cashflowChartData = useSelector(state => state.apiResponseReducers.cashflowChartData)
  // const loadingCashflowChartData = useSelector(state => state.apiResponseReducers.loadingCashflowChartData)
  const summaryCashflowData = useSelector(state => state.apiResponseReducers.summaryCashflowData)

  const [confirmationDialog, setConfirmationDialog] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false)

  useEffect(() => {
    if (isFreeAccount || !accountCodatConnected) setShowOverlay(false)
  }, [isFreeAccount, accountCodatConnected])

  const onDisconnectApp = async () => {
    try {
      await api.disconnectApp(companyId, connectionId)
      dispatch({ type: actionTypes.ACCOUNTCODATDISCONNECTED })
    } catch (error) {
      console.log(error)
    }
  }

  const [formattedChartData, setFormattedChartData] = useState([])
  // const [onRefresh, setOnRefresh] = useState(null)

  useEffect(() => {
    if (accountCodatConnected) api.getCashflowChartData(companyId, daySpanSelected)
    // eslint-disable-next-line
  }, [daySpanSelected, accountCodatConnected])

  useEffect(() => {
    if (cashflowChartData) {
      const formattedData = cashflowChartData.map(data => ({
        timestamp: new Date(data.date),
        money_in_number: Math.abs(data?.money_in),
        money_out_number: Math.abs(data?.money_out),
      }))

      setFormattedChartData(formattedData)
    }
  }, [cashflowChartData])

  useEffect(() => {
    if (accountCodatConnected) {
      // GET CODAT CONNECT INFO FOR USER
      api.getCodatConnectUserInfo()
    }
  }, [accountCodatConnected])

  const onDaySpanClicked = async days => {
    dispatch({ type: actionTypes.SETFINANCIALOVERVIEWDAYSPAN, data: days })
  }

  const handleClickConnect = e => {
    e && e.preventDefault()
    handleCodat()
  }

  const handleMouseEnter = () => {
    if (!accountCodatConnected || (isFreeAccount && accountCodatConnected)) {
      setShowOverlay(true)
    }
  }

  const handleMouseLeave = () => {
    if (!accountCodatConnected || (isFreeAccount && accountCodatConnected)) {
      setShowOverlay(false)
    }
  }

  const handleCodat = () => {
    if (isFreeAccount) {
      dispatch({ type: actionTypes.TOGGLESUBSCRIPTIONMODAL, data: true })
    } else {
      if (codatIntegrated) {
        if (accountCodatConnected && !commerceCodatConnected) {
          window.location.replace(`https://links.codat.io/company/${companyId}/link/commerce`)
        } else if (commerceCodatConnected && !accountCodatConnected) {
          window.location.replace(`https://links.codat.io/company/${companyId}/link/accounting`)
        } else {
          window.location.replace(`https://links.codat.io/company/${companyId}`)
        }
      } else {
        dispatch({ type: actionTypes.TOGGLECOMPANYNAMEMODAL, data: true })
      }
    }
  }

  // const handleRefresh = async () => {
  //   if (codatConnected) {
  //     setOnRefresh(true)
  //     await api.getCashflowChartData(companyId, daySpanSelected)
  //   }
  // }

  const tooltipContent = (
    <Typography variant="body2" color="white">
      Link your accounting software to get a consolidated view of key metrics.
    </Typography>
  )

  return (
    <Box
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      {showOverlay && (!accountCodatConnected || (accountCodatConnected && isFreeAccount)) && (
        <Overlay>
          <Box
            sx={{
              height: 'calc(100% - 100px)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-around',
            }}
          >
            <Typography
              variant="h5"
              color="white"
              sx={{
                background: theme.palette.background.primary,
                WebkitTextFillColor: 'transparent',
                WebkitBackgroundClip: 'text',
              }}
            >
              Monitor Cashflow
            </Typography>
            <Typography
              component="div"
              variant="body1B"
              color="white"
              sx={{
                width: '70%',
                textAlign: 'center',
                marginBottom: 2,
              }}
            >
              See historical data, current cashflow, payables, and receivables by connecting your accounting app.
            </Typography>
            <Box>
              <ImageList cols={3} gap={15}>
                {items.map(item => (
                  <ImageListItem
                    key={item.title}
                    sx={{
                      width: '80px',
                      height: '80px !important',
                      padding: '10px',
                      background: 'white',
                      borderRadius: 2,
                    }}
                  >
                    <img src={item.logoUrl} alt={item.title} loading="lazy" style={{ objectFit: 'contain' }}></img>
                  </ImageListItem>
                ))}
              </ImageList>
            </Box>
          </Box>
          {isFreeAccount && (
            <Box marginTop="30px">
              <ConnectButton label="Connect your accounting app" />
            </Box>
          )}
        </Overlay>
      )}

      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          padding: '25px',
        }}
      >
        <CardHeader>
          <Box>
            <SectionTitle title="Cashflow" />
            &nbsp;
            <ToolTip content={tooltipContent} />
          </Box>
          <Box sx={{ display: 'flex' }}>
            <DaySpan onClick={onDaySpanClicked} daySpanSelected={daySpanSelected} />
            {accountCodatConnected && (
              <ButtonTooltip
                placement={'top'}
                title={'Disconnect App'}
                arrow
                onClick={() => setConfirmationDialog(true)}
              >
                <img
                  src={linkOffSvg}
                  height="20px"
                  width="20px"
                  alt={'sales-disconnect-button'}
                  style={{ cursor: 'pointer', marginLeft: '20px' }}
                />
              </ButtonTooltip>
            )}
            {/* {accountCodatConnected && <MenuButton onClickDisconnect={() => setConfirmationDialog(true)} />} */}
          </Box>
        </CardHeader>
        {!accountCodatConnected && (
          <CardBody>
            <ChartPlaceholder
            // onClick={() => {
            //   dispatch({ type: actionTypes.SHOWFINANCEDIALOG })
            // }}
            >
              <img src={cashflowPlaceholderSvg} style={{ width: '100%', height: '100%' }} alt="Cashflow-Placeholder" />
              <Typography
                variant="h1"
                sx={{
                  cursor: 'default',
                  position: 'absolute',
                  opacity: '0.4',
                  userSelect: 'none',
                  color: theme.palette.color.darkBlue10,
                  mixBlendMode: 'multiply',
                }}
              >
                Sample Data
              </Typography>
            </ChartPlaceholder>

            {isFreeAccount && <ConnectButton label="Connect your accounting app" />}
            {!isFreeAccount && (
              <ConnectButton
                sx={{ zIndex: theme.zIndex.overlay }}
                onClick={handleClickConnect}
                label="Connect your accounting app"
                isConnected={accountCodatConnected}
              />
            )}
          </CardBody>
        )}

        {accountCodatConnected && (
          <CardBody
            onClick={() => {
              dispatch({ type: actionTypes.SHOWFINANCEDIALOG })
            }}
          >
            <Chart
              style={{
                width: '100%',
                height: '100%',
              }}
            >
              <ChartLegend position="bottom" spacing={40} />
              <ChartTooltip />
              <ChartArea background={'transparent'} />
              <ChartAxisDefaults
                line={{
                  color: 'grey',
                }}
                minorGridLines={{
                  visible: false,
                }}
                majorGridLines={{
                  visible: false,
                }}
                visible={true}
              />
              <ChartValueAxis>
                <ChartValueAxisItem
                  labels={{
                    format: 'c0',
                  }}
                />
              </ChartValueAxis>
              <ChartCategoryAxis>
                <ChartCategoryAxisItem baseUnits={'days'} majorGridLines={{ visible: true }} maxDivisions={10} />
              </ChartCategoryAxis>
              <ChartLegend position="bottom" labels={{ color: '#25245F' }} />
              <ChartSeries>
                <ChartSeriesItem
                  type="line"
                  name={`Money In: ${
                    summaryCashflowData?.money_in_sum
                      ? formatCurrency(parseFloat(summaryCashflowData.money_in_sum))
                      : ''
                  }`}
                  style={seriesStyle}
                  data={formattedChartData}
                  field="money_in_number"
                  categoryField="timestamp"
                  color="#469CF8"
                  markers={{ visible: false }}
                >
                  <ChartSeriesItemTooltip background="#469CF8" format="c2" />
                </ChartSeriesItem>
                <ChartSeriesItem
                  type="line"
                  name={`Money Out: ${
                    summaryCashflowData?.money_out_sum
                      ? formatCurrency(parseFloat(summaryCashflowData.money_out_sum))
                      : ''
                  }`}
                  style={seriesStyle}
                  data={formattedChartData}
                  field="money_out_number"
                  categoryField="timestamp"
                  color="#00CBA9"
                  markers={{ visible: false }}
                >
                  <ChartSeriesItemTooltip background="#00CBA9" format="c2" />
                </ChartSeriesItem>
              </ChartSeries>
            </Chart>
          </CardBody>
        )}
      </Box>

      <ConfirmDialog
        show={confirmationDialog}
        setShow={setConfirmationDialog}
        onSuccess={onDisconnectApp}
        SuccessMessage="Disconnect"
        title="Are you sure?"
        content="If so, you will have the opportunity to log back in and reconnect your application to display company data in this tile."
        content2="Do you want to proceed with disconnecting your application from this tile?"
      />
    </Box>
  )
}

export default CashFlowCard
